import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { defaultBorder, errorBorder } from 'shared/constants'
import { DepArrCountryBlock } from 'shared/ui/dep-arr-country-block'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface FieldValue {
  name?: string
  code?: string
}

interface Props {
  from?: FieldValue
  to?: FieldValue
  date?: string
  onClickFrom?: () => void
  onClickTo?: () => void
  onClickDate?: () => void
  onSwitch?: () => void
  fromError?: boolean
  toError?: boolean
  dateError?: boolean
}

export const FlightSegmentFields: FC<Props> = ({
  from,
  to,
  date,
  onClickFrom,
  onClickTo,
  onClickDate,
  onSwitch,
  fromError,
  toError,
  dateError,
}) => {
  const { t } = useTranslation()

  return (
    <div className={s.fields}>
      <DepArrCountryBlock
        type="lightGrey"
        padding={[0, 16]}
        from={from}
        to={to}
        onClick={(name) => (name === 'from' ? onClickFrom?.() : onClickTo?.())}
        onSwitch={onSwitch}
        error={fromError || toError}
      />

      <Paper
        type="lightGrey"
        radius={16}
        padding={[0]}
        border={dateError ? errorBorder : defaultBorder}
      >
        <button
          type="button"
          className={s.row}
          onClick={onClickDate}
        >
          {date ? (
            <div className={s.box}>
              <span className={clsx(s.label, 'medium-12')}>{t('when')}</span>
              <span className={s.value}>{date}</span>
            </div>
          ) : (
            <span className={s.placeholder}>{t('when')}</span>
          )}
        </button>
      </Paper>
    </div>
  )
}
